import React, {useEffect} from "react";
import { Facility } from "../components/Facility";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEnvelope,faFax, faLocationDot,faPhone,} from "@fortawesome/free-solid-svg-icons";
import { faBehance, faFacebook, faInstagram, faLinkedinIn, faPinterest, faSkype, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

export const Contact = () => {

  useEffect(() => {
    document.title = 'Contact Us'; // Set the title to "Contact" when this component mounts
  }, []);
  return (
    <div>
      <section className="contact">
        <div className="container py-5">
          <div className="row text-center py-5" data-aos="fade-down" data-aos-duration="1000">
            <h2 className="f-34 fw-700">Contact Us</h2>
          </div>

          <div className="row">
            <div className="col-lg-5">
              <h3 className="f-18 fw-700" >Here to Help</h3>
              <p>Have a question? You may find an answer in our FAQs. But you can
                also contact us.
              </p>
              <ul className="list-unstyled">
                <li className="pb-2">
                  <a
                    href="https://goo.gl/maps/ERQT2Fc9bTpVvqe38"
                    className="d-flex align-items-center"
                    target="_blank"
                  >
                    <FontAwesomeIcon className="me-2" icon={faLocationDot} />{" "}
                    <span className="ms-1 f-18">
                      Location: 2750 Quadra Street Victoria, Canada{" "}
                    </span>
                  </a>
                </li>
                <li className="pb-2">
                  <a
                    href="tel:(+123) 456-7898"
                    className="d-flex align-items-center"
                  >
                    <FontAwesomeIcon className="me-2" icon={faPhone} />
                    <span className="f-18">Call Us: (+123) 456-7898</span>
                  </a>
                </li>
                <li className="pb-2">
                  <a
                    href="mailto:support@novine.com"
                    className="d-flex align-items-center text-nowrap"
                  >
                    <FontAwesomeIcon className="me-2" icon={faEnvelope} />
                    <span className="f-18">Email Us: support@novine.com</span>
                  </a>
                </li>

                <li className="pb-2">
                  <a href="tel:+123456">
                    <FontAwesomeIcon className="me-2" icon={faFax} />
                    <span className="f-18">Fax: +123456</span>
                  </a>
                </li>
              </ul>
              <h3 className="f-18 fw-700">Opening Hours:</h3>
              <ul className="list-unstyled">
                <li><span>Monday:</span> 8AM - 6AM</li>
                <li><span>Tuesday:</span> 8AM - 6AM</li>
                <li><span>Wednesday:</span> 8AM - 6AM</li>
                <li><span>Thursday - Friday:</span> 8AM - 6AM</li>
                <li><span>Sunday:</span> Closed</li>
              </ul>
              <h3 className="f-18 fw-700">Follow Us:</h3>
              <ul className="list-unstyled d-flex">
                <li className="pe-2">
                  <a
                    href="https://www.facebook.com"
                    target="_blank"
                    aria-label="Facebook link"
                  >
                    <FontAwesomeIcon className="me-3" icon={faFacebook} />
                  </a>
                </li>
                <li className="pe-2">
                  <a
                    href="https://www.twitter.com"
                    target="_blank"
                    aria-label="Linkedin link"
                  >
                    <FontAwesomeIcon className="me-3" icon={faTwitter} />
                  </a>
                </li>
                <li className="pe-2">
                
                  <a
                    href="https://www.instagram.com"
                    target="_blank"
                    aria-label="Instagram link"
                  >
                    <FontAwesomeIcon className="me-3" icon={faInstagram} />
                  </a>
                </li>
                <li className="pe-2">
                
                <a
                  href="https://www.behance.com"
                  target="_blank"
                  aria-label="Instagram link"
                >
                  <FontAwesomeIcon className="me-3" icon={faBehance} />
                </a>
              </li>
              <li className="pe-2">
                
                <a
                  href="https://www.skype.com"
                  target="_blank"
                  aria-label="Instagram link"
                >
                  <FontAwesomeIcon className="me-3" icon={faSkype} />
                </a>
              </li>
              <li className="pe-2">
                
                <a
                  href="https://www.pinterest.com"
                  target="_blank"
                  aria-label="Instagram link"
                >
                  <FontAwesomeIcon className="me-3" icon={faPinterest} />
                </a>
              </li>
              <li className="pe-2">
                
                <a
                  href="https://www.youtube.com"
                  target="_blank"
                  aria-label="Instagram link"
                >
                  <FontAwesomeIcon className="me-3" icon={faYoutube} />
                </a>
              </li>
              </ul>

            </div>

            <div className="col-lg-7 mt-3 mt-md-0">
            <h3 className="f-18 fw-700">Drop Us A Line</h3>
            <p>We’re happy to answer any questions you have or provide you with an estimate. Just send us a message in the form below with any questions you may have.</p>
             <form>
                <div className="">
                
                    <div class="form-group mb-3">
                        <label>NAME <span>(required)*</span></label>
                        <input type="text" name="name" id="name" class="form-control" required="" placeholder="Enter your Name" />
                           
                    </div>
                    <div class="form-group mb-3">
                        <label>EMAIL <span>(required)*</span></label>
                        <input type="text" name="email" id="email" class="form-control" required="" placeholder="Enter your Email Address" />
                           
                    </div>
                    <div class="form-group mb-3">
                        <label>PHONE NUMBER <span>(required)*</span></label>
                        <input type="phone" name="phone" id="phone" class="form-control" required="" placeholder="Enter your Phone Number" />
                           
                    </div>
                    <div class="form-group mb-3">
                        <label>YOUR MESSAGE <span>(required)*</span></label>
                        <textarea type="text" name="message" id="message" class="form-control" required="" placeholder="Enter your Message" rows="5" ></textarea>
                           
                    </div>
                    <div>
                    <button type="submit" className="btn-1">
                         SEND MESSAGE 
                    </button>
                    </div>
                </div>
             </form>

            </div>
          </div>
        </div>
      </section>

      <Facility />
    </div>
  );
};